import { useState, useCallback, useEffect } from 'react';

export const useCheck = (isIntro, isLoggedIn, subscribePeriod, isBasicUser, subscribePrice) => {
  const [isShow, setIsShow] = useState(false);
  const onClose = useCallback(() => setIsShow(false), [setIsShow]);

  useEffect(() => {
    if (!isLoggedIn) return;
    if (isIntro || subscribePeriod >= 12 || subscribePrice === 0) {
      setIsShow(false);
    } else if (!isIntro && (subscribePeriod < 12 || isBasicUser)) {
      setIsShow(true);
    }
  }, [isIntro, setIsShow, isLoggedIn, subscribePeriod, isBasicUser, subscribePrice]);

  return [isShow, onClose];
};
